import { useCallback, useEffect, useRef } from 'react'

export default function useDebouncedFunction(func: () => void, delay: number) {
  const ref = useRef<NodeJS.Timeout | null>(null)
  const funcRef = useRef(func)
  funcRef.current = func

  const debouncedFunc = useCallback(() => {
    if (ref.current) {
      clearTimeout(ref.current)
    }
    ref.current = setTimeout(() => funcRef.current(), delay)
  }, [delay])

  useEffect(() => {
    return () => {
      if (ref.current) {
        clearTimeout(ref.current)
      }
    }
  }, [])

  return debouncedFunc
}
